import classNames from "classnames";
import { useEffect, useState } from "react";
import styles from "./forecast.module.css";
import { HourlyCast } from "../../components/hourcast/HourlyCast";
import { Footer, ForecastHero, Highlights, WeatherTendecies } from "../../components";
import { useLanguage } from "../../components/contexts/LanguageContext";
import { useGetDefaultOU } from "../../hooks/orgunits/useGetDefaultOU";
import { useParams } from "../../hooks/common/useParams";

const Forecast: React.FC = () => {
  const { setSelectedLanguage } = useLanguage();
  const { loading, ous } = useGetDefaultOU();
  const { useUrlParamiters, add } = useParams()
  const { orgUnit, orgUnitName, parentId} = useUrlParamiters()

  useEffect(() => {
    if (ous?.defaultOu && !orgUnit && !orgUnitName && !parentId) {
      add("orgUnit", ous.defaultOu.id);
      add("orgUnitName", ous.defaultOu.name);
      add("parentId", ous.defaultOu.parent?.id);
    }
  }, [ous]);

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedLanguage(e.target.value as 'pt' | 'en');
  };

  return (
    <div className={styles.forecastContainer}>
      <ForecastHero />
      <main className={classNames(styles.layout, "container")}>
        <HourlyCast />
        <Highlights />
        <WeatherTendecies />
      </main>
      <Footer />
    </div>
  );
};

export { Forecast };
